<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{
        this.$route.query.orderId == undefined ? "订单新增" : "新增售后订单"
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <dev>
      <el-form
        ref="form"
        :model="orderData.order"
        :rules="newOrderFormRules"
        label-width="80px"
        size="mini"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item prop="orderNo" label="订单编号">
              <el-input
                v-model="orderData.order.orderNo"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单状态">
              <el-select
                v-model="orderData.order.orderStatus"
                placeholder="请选择订单状态"
                style="width: 80%"
              >
                <el-option label="预备订单" value="预备订单"></el-option>
                <el-option label="报价完成" value="报价完成"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="接单时间">
              <el-date-picker
                v-model="orderData.order.orderDateTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                disabled
                style="width: 80%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="margin-left: 0%">
            <el-form-item label="接单客服">
              <el-input
                v-model="orderData.order.orderReceivPerson"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="margin-left: -2%">
            <el-form-item label="开单员">
              <el-input
                v-model="orderData.order.billingPerson"
                style="width: 70%"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4"><p class="text_l">基本信息</p></el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item prop="shop" label="订货店铺">
              <el-autocomplete
                class="inline-input"
                v-model="orderData.order.shop"
                :fetch-suggestions="querySearchShop"
                placeholder="店铺"
                @select="handleSelectShop"
                value-key="shop"
                :validate-event="false"
                style="width: 80%"
              >
                <template slot-scope="{ item }">
                  <span>{{ item.shop }}</span>
                  <span style="font-size: 12px; color: #868686">{{
                    "(" + item.phone + ")"
                  }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="shippingClerk" label="发货员">
              <el-input
                v-model="orderData.order.shippingClerk"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="shopPhone" label="店铺电话">
              <el-input
                v-model="orderData.order.shopPhone"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="shipAddr" label="发货地址">
              <el-input
                v-model="orderData.order.shipAddr"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item prop="customerId" label="客户ID">
              <el-autocomplete
                class="inline-input"
                v-model="orderData.order.customerId"
                :fetch-suggestions="querySearchCustomer"
                placeholder="客户ID"
                @select="handleSelectCustomer"
                value-key="customerId"
                :validate-event="false"
                style="width: 80%"
                @blur="getCustomerBuyCount()"
              >
                <template slot-scope="{ item }">
                  <span>{{ item.customerId }}</span>
                  <span style="font-size: 12px; color: #868686">{{
                    "(" + item.customerPhone + ")"
                  }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="customerName" label="客户姓名">
              <el-input
                v-model="orderData.order.customerName"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="customerPhone" label="客户电话">
              <el-input
                v-model.trim="orderData.order.customerPhone"
                style="width: 80%"
                @blur="getCustomerBuyCount()"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="customerAddr" label="收货地址">
              <el-input
                v-model="orderData.order.customerAddr"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4"><p class="text_l">订单信息</p></el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="订单类型" style="width: 90%">
              <el-select
                v-model="orderData.order.orderType"
                placeholder="请选择订单类型"
                style="width: 90%"
                :disabled="this.$route.query.orderId !== undefined"
              >
                <el-option label="普通订单" value="普通订单"></el-option>
                <el-option label="加急订单" value="加急订单"></el-option>
                <el-option label="出库订单" value="出库订单"></el-option>
                <el-option label="库存订单" value="库存订单"></el-option>
                <el-option label="返工订单" value="返工订单"></el-option>
                <el-option label="退货订单" value="退货订单"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="4">
            <el-form-item prop="duty" label="责任界定" style="width: 90%;">
              <el-select v-model="orderData.order.duty" placeholder="请选择">
                <el-option label="销售责任" value="销售责任"></el-option>
                <el-option label="生产责任" value="生产责任"></el-option>
                <el-option label="共同责任" value="共同责任"></el-option>
                <el-option label="售前客服责任" value="售前客服责任"></el-option>
                <el-option label="物流运输责任" value="物流运输责任"></el-option>
                <el-option label="售后质保" value="售后质保"></el-option>
                <el-option label="客户自购" value="客户自购"></el-option>
                <el-option label="安装错误" value="安装错误"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="4">
            <el-form-item prop="deliveryDate" label="发货日期">
              <el-date-picker
                :picker-options="pickerOptions"
                v-model="orderData.order.deliveryDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择发货日期"
                style="width: 90%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item prop="installRequirements" label="安装要求">
              <el-input
                v-model="orderData.order.installRequirements"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="pickUpGoodsPhone" label="提货电话">
              <el-autocomplete
                class="inline-input"
                v-model="orderData.order.pickUpGoodsPhone"
                :fetch-suggestions="querySearchPickUpGoodsPhone"
                placeholder="提货电话"
                @select="handleSelectPickUpGoodsPhone"
              >
                <template slot-scope="{ item }">
                  <span>{{ item }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4"><p class="text_l">产品信息</p></el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item prop="productName" label="产品名称">
              <el-input
                v-model="orderData.order.productName"
                style="width: 90%"
                :disabled="this.$route.query.inventoryId != undefined"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="colour" label="颜色">
              <el-input
                v-model="orderData.order.colour"
                style="width: 90%"
                :disabled="this.$route.query.inventoryId != undefined"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="speModel" label="规格型号">
              <el-input
                v-model="orderData.order.speModel"
                style="width: 90%"
                :disabled="this.$route.query.inventoryId != undefined"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="packingRequirements" label="包装要求">
              <el-select
                v-model="orderData.order.packingRequirements"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option label="纸箱" value="纸箱"></el-option>
                <el-option label="木架" value="木架"></el-option>
                <el-option
                  label="易碎物木框+纸箱"
                  value="易碎物木框+纸箱"
                ></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="logisticsMode" label="发货方式">
              <el-select
                v-model="orderData.order.logisticsMode"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option label="送货安装" value="送货安装"></el-option>
                <el-option label="送货楼下" value="送货楼下"></el-option>
                <el-option label="送货楼上" value="送货楼上"></el-option>
                <el-option label="客户自提" value="客户自提"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item prop="quantity" label="套数">
              <el-input
                v-model="orderData.order.quantity"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="totalMoney" label="订单金额">
              <el-input
                v-model="orderData.order.totalMoney"
                @blur="writeLaterMoney()"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="付款方式">
              <el-select
                v-model="orderData.order.paymentMethod"
                placeholder="请选择"
                @change="payMChange"
                style="width: 90%"
              >
                <el-option label="现金" value="现金"></el-option>
                <el-option label="月结" value="月结"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="prepay" label="预付">
              <el-input
                v-model="orderData.order.prepay"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="monthBond" label="月结">
              <el-input
                v-model="orderData.order.monthBond"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top: 0%">
          <el-col :span="4">
            <el-form-item prop="sheetMaterial" label="板材材料">
              <el-select
                v-model="orderData.order.sheetMaterial"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option label="实木多层板" value="实木多层板"></el-option>
                <el-option label="实木颗粒板" value="实木颗粒板"></el-option>
                <el-option
                  label="实木颗粒板和多层板混合"
                  value="实木颗粒板和多层板混合"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item prop="customerBuy" label="客户第几次购买">
              <el-input
                v-model="orderData.order.customerBuy"
                style="width: 90%"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item prop="payTime" label="付款时间">
              <el-date-picker
                v-model="orderData.order.payTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择付款时间"
                style="width: 90%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              label="备注"
              width="200%"
              show-overflow-tooltip="false"
            >
              <el-input
                type="textarea"
                v-model="orderData.order.remarks"
                style="width: 95%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item prop="giftPurchasing" label="赠品采购">
              <el-input
                v-model="orderData.order.giftPurchasing"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="afterPurchasing" label="售后采购">
              <el-input
                v-model="orderData.order.afterPurchasing"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="transactionRefundOptions" label="交易退款选项">
              <el-input
                v-model="orderData.order.transactionRefundOptions"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="clickFarming" label="刷单">
              <el-input
                v-model="orderData.order.clickFarming"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="returnMoney" label="返现">
              <el-input
                v-model="orderData.order.returnMoney"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item prop="freight" label="运费">
              <el-input
                v-model="orderData.order.freight"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="orderData.order.inventoryNo != undefined">
            <el-form-item prop="inventoryNo" label="库存编号">
              <el-input
                v-model="orderData.order.inventoryNo"
                style="width: 90%"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top: 1%">
          <el-col :span="4">
            <el-form-item size="large">
              <el-button type="primary" @click="onSubmit">保存订单</el-button>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item>
              <el-upload
                action="/api/file/upload"
                :on-success="uploadImageSuccess"
                :headers="myHeaders"
                :show-file-list="false"
                multiple
              >
                <el-button size="small" type="primary">点击上传图片</el-button>
                <div slot="tip" class="el-upload__tip">
                  只支持jpg/png文件，不超过500kb
                </div>
              </el-upload>
            </el-form-item>
          </el-col>

          <draggable
            v-model="orderData.fileInfoList"
            :move="onMove"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <transition-group type="transition">
              <dev
                style="margin-left: 1%"
                v-for="item in orderData.fileInfoList"
                :key="item"
                class="item"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="item.fileUrl"
                  :preview-src-list="[item.fileUrl]"
                >
                </el-image>
                <el-button
                  @click="delImage(item.fileUrl)"
                  style="color: red"
                  size="mini"
                  >删除</el-button
                >
              </dev>
            </transition-group>
          </draggable>
        </el-row>
      </el-form>
    </dev>
  </div>
</template>

<script>
var token = window.localStorage.getItem("token");
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data() {
    var numberCheck = async (rule, value, cb) => {
      var regular = /^[0-9]*$/;
      if (!regular.test(value)) {
        return cb(new Error("只能填写数字!"));
      }
    };
    var orderNoCheck = async (rule, value, cb) => {
      var regular = /^[0-9a-zA-Z-_]{1,}$/;
      if (!regular.test(value)) {
        return cb(new Error("只能由字母数字和-_组成,可能包含空格或制表符!"));
      }

      const { data: res } = await this.$http.get(
        "/api/order/order-no-check/" + value
      );
      if (res.code !== 1) {
        return cb(new Error("订单号已存在，请更换订单号！"));
      }
    };
    var moneyCheck = async (rule, value, cb) => {
      var isNum = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !isNum.test(value)
      ) {
        return cb(new Error("请输入标准金额！"));
      }
    };
    var speModelCheck = async (rule, value, cb) => {
      var regular = /^[0-9*/]{1,}$/;
      if (!regular.test(value)) {
        return cb(new Error("只能包含数字*/"));
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          //设置选择今天以及今天之后的日期
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      myHeaders: { Authorization: token },
      orderData: {
        order: {
          orderNo: "",
          orderStatus: "预备订单",
          orderDateTime: "",
          shop: "",
          shippingClerk: "",
          shopPhone: "",
          shipAddr: "",
          customerId: "",
          customerName: "",
          customerPhone: "",
          customerAddr: "",
          orderType: "普通订单",
          duty: null,
          deliveryDate: "",
          contractId: "",
          productName: "",
          colour: "",
          speModel: "",
          packingRequirements: "",
          logisticsMode: "",
          quantity: "",
          totalMoney: "",
          paymentMethod: "",
          prepay: "",
          monthBond: "",
          installRequirements: "",
          pickUpGoodsPhone: "",
          remarks: "",
          orderReceivPerson: "",
          billingPerson: "",
          printCount: 0,
          customerBuy: 1,
        },
        fileInfoList: [],
      },
      newOrderFormRules: {
        orderNo: [
          { required: true, message: "请填写订单编号", trigger: "blur" },
          { validator: orderNoCheck, trigger: "blur" },
        ],
        deliveryDate: [
          { required: true, message: "请选择发货日期", trigger: "blur" },
        ],
        shop: [{ required: true, message: "订货店铺", trigger: "blur" }],
        shopPhone: [{ required: true, message: "店铺电话", trigger: "blur" }],
        shipAddr: [{ required: true, message: "发货地址", trigger: "blur" }],
        customerId: [{ required: true, message: "客户ID", trigger: "blur" }],
        customerName: [
          { required: true, message: "客户姓名", trigger: "blur" },
        ],
        customerPhone: [
          { required: true, message: "客户电话", trigger: "blur" },
          { validator: numberCheck, trigger: "blur" },
        ],
        customerAddr: [
          { required: true, message: "收货地址", trigger: "blur" },
        ],
        productName: [{ required: true, message: "产品名称", trigger: "blur" }],
        colour: [{ required: true, message: "颜色", trigger: "blur" }],
        speModel: [
          { required: true, message: "规格型号", trigger: "blur" },
          { validator: speModelCheck, trigger: "blur" },
        ],
        packingRequirements: [
          { required: true, message: "请选择包装要求", trigger: "blur" },
        ],
        logisticsMode: [
          { required: true, message: "请选择发货方式", trigger: "blur" },
        ],
        quantity: [{ required: true, message: "套数", trigger: "blur" }],
        totalMoney: [
          { required: true, message: "应收总额", trigger: "blur" },
          { validator: moneyCheck, trigger: "blur" },
        ],
        prepay: [{ validator: moneyCheck, trigger: "blur" }],
        monthBond: [{ validator: moneyCheck, trigger: "blur" }],
        sheetMaterial: [
          { required: true, message: "板材材料", trigger: "blur" },
        ],
        payTime: [{ required: true, message: "付款时间", trigger: "blur" }],
        pickUpGoodsPhone: [
          { required: true, message: "提货电话", trigger: "blur" },
        ],
      },
      shopList: [],
      shopTotal: 0,
      shopInfo: null,

      customerList: [],
      customerTotal: 0,
      customerInfo: null,

      pickUpGoodsPhoneList: [],
      selectPickUpGoodsPhone: null,

      orderImageSrcS: [],
      orderImageFileInfoList: [],
    };
  },
  methods: {
    onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (
            this.shopInfo == null ||
            this.shopInfo.shop != this.orderData.order.shop
          ) {
            let shopInfo = {
              shop: this.orderData.order.shop,
              phone: this.orderData.order.shopPhone,
              contacts: this.orderData.order.shippingClerk,
              addr: this.orderData.order.shipAddr,
              submitter: window.localStorage.getItem("userCompellation"),
              comCode: window.localStorage.getItem("userComCode"),
            };
            this.$http.post("/api/agency-info/createAndModif", shopInfo);
          }

          if (
            this.customerInfo == null ||
            this.customerInfo.customerId != this.orderData.order.customerId ||
            this.customerInfo.customerName !=
              this.orderData.order.customerName ||
            this.customerInfo.customerPhone !=
              this.orderData.order.customerPhone ||
            this.customerInfo.customerAddr != this.orderData.order.customerAddr
          ) {
            let customerInfo = {
              customerId: this.orderData.order.customerId,
              customerName: this.orderData.order.customerName,
              customerPhone: this.orderData.order.customerPhone,
              customerAddr: this.orderData.order.customerAddr,
              submitter: window.localStorage.getItem("userCompellation"),
              comCode: window.localStorage.getItem("userComCode"),
            };
            this.$http.post("/api/customer-info/createAndModif", customerInfo);
          }

          if (
            this.selectPickUpGoodsPhone !==
            this.orderData.order.pickUpGoodsPhone
          ) {
            this.pickUpGoodsPhoneList.push(
              this.orderData.order.pickUpGoodsPhone
            );
            window.localStorage.setItem(
              "pickUpGoodsPhoneList",
              JSON.stringify(this.pickUpGoodsPhoneList)
            );
          }

          const { data: res } = await this.$http.post(
            "/api/order/create",
            this.orderData
          );
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success",
            });

            //当前客户购买加1
            this.orderData.order.customerBuy++;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        } else {
          this.$message({
            message: "有必填项未填写或不合法！",
            type: "error",
          });
          return false;
        }
      });
    },
    initParams() {
      //this.orderData.order.orderNo = "9"+new Date().getTime()
      this.orderData.order.orderDateTime = this.getNowFormatDateTime();
      this.orderData.order.orderReceivPerson =
        window.localStorage.getItem("userCompellation");
      this.orderData.order.billingPerson =
        window.localStorage.getItem("userCompellation");
    },
    payMChange(val) {
      if (val === "现金") {
        if (
          this.orderData.order.monthBond === this.orderData.order.totalMoney
        ) {
          this.orderData.order.monthBond = "";
        }
        this.orderData.order.prepay = this.orderData.order.totalMoney;
      } else if (val === "月结") {
        if (this.orderData.order.prepay === this.orderData.order.totalMoney) {
          this.orderData.order.prepay = "";
        }
        this.orderData.order.monthBond = this.orderData.order.totalMoney;
      }
    },

    //店铺输入建议
    querySearchShop(queryString, cb) {
      var shopList = this.shopList;
      var results = queryString
        ? shopList.filter(this.createFilterShop(queryString))
        : shopList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilterShop(queryString) {
      return (shopInfo) => {
        return (
          shopInfo.shop.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    async loadShopInfo() {
      const { data: res } = await this.$http.post("/api/agency-info/get", {
        sortByFieldName: "order_total",
        sortType: true,
        pageNum: 1,
        pageSize: 100,
      });
      if (res.code == 1) {
        this.shopList = res.data.dataList;
        this.shopTotal = res.data.total;
      }
    },
    handleSelectShop(item) {
      //console.log(item);
      this.shopInfo = item;
      this.orderData.order.shopPhone = item.phone;
      this.orderData.order.shippingClerk = item.contacts;
      this.orderData.order.shipAddr = item.addr;
    },

    //客户输入建议
    querySearchCustomer(queryString, cb) {
      var customerList = this.customerList;
      var results = queryString
        ? customerList.filter(this.createFilterCustomer(queryString))
        : customerList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilterCustomer(queryString) {
      return (customerInfo) => {
        return (
          customerInfo.customerId
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    async loadCustomerInfo() {
      const { data: res } = await this.$http.post("/api/customer-info/get", {
        pageNum: 1,
        pageSize: 300,
      });
      if (res.code == 1) {
        this.customerList = res.data.dataList;
        this.customerTotal = res.data.total;
      }
    },
    handleSelectCustomer(item) {
      //console.log(item);
      this.customerInfo = item;
      this.orderData.order.customerName = item.customerName;
      this.orderData.order.customerPhone = item.customerPhone;
      this.orderData.order.customerAddr = item.customerAddr;

      this.getCustomerBuyCount();
    },

    //提货电话输入建议
    querySearchPickUpGoodsPhone(queryString, cb) {
      var pickUpGoodsPhoneList = this.pickUpGoodsPhoneList;
      var results = queryString
        ? pickUpGoodsPhoneList.filter(
            this.createFilterPickUpGoodsPhone(queryString)
          )
        : pickUpGoodsPhoneList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilterPickUpGoodsPhone(queryString) {
      return (pickUpGoodsPhone) => {
        return (
          pickUpGoodsPhone.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelectPickUpGoodsPhone(item) {
      this.orderData.order.pickUpGoodsPhone = item;
      this.selectPickUpGoodsPhone = item;
    },
    async loadPickUpGoodsPhoneList() {
      this.pickUpGoodsPhoneList =
        window.localStorage.getItem("pickUpGoodsPhoneList") !== null
          ? JSON.parse(window.localStorage.getItem("pickUpGoodsPhoneList"))
          : [];
    },
    uploadImageSuccess(response) {
      if (response.code == 1) {
        this.orderData.fileInfoList.push(response.data);
      } else {
        this.$message({
          message: response.msg,
          type: "error",
        });
      }
    },
    delImage(fileUrl) {
      for (let i = 0; i < this.orderData.fileInfoList.length; i++) {
        if (this.orderData.fileInfoList[i].fileUrl == fileUrl) {
          this.orderData.fileInfoList.splice(i, 1);
          break;
        }
      }
    },
    // 图片移动
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.item;
      const draggedElement = draggedContext.item;
    },
    async getCustomerBuyCount() {
      console.log("输入完毕");

      if (
        this.orderData.order.customerId == "" ||
        this.orderData.order.customerPhone == ""
      ) {
        return;
      }

      let customerBuyCountParam = {
        customerId: this.orderData.order.customerId,
        customerPhone: this.orderData.order.customerPhone,
      };

      const { data: res } = await this.$http.post(
        "/api/order/get-customer-buy-count",
        customerBuyCountParam
      );
      if (res.code == 1) {
        this.orderData.order.customerBuy = res.data + 1;
      }
    },
    async getOrderInfo(orderId) {
      const { data } = await this.$http.get(
        "/api/order/getByIdOrderTable/" + orderId
      );
      if (data.code == 1) {
        this.orderData.order = data.data;
        this.orderData.order.id = null;
        this.orderData.order.orderStatus = "预备订单";
        this.orderData.order.orderType = "返工订单";
        this.orderData.order.orderNo = this.orderData.order.orderNo + "s";
        this.orderData.order.orderDateTime = this.getNowFormatDateTime();
        this.orderData.order.orderReceivPerson =
          window.localStorage.getItem("userCompellation");
        this.orderData.order.remarks = "";
        this.orderData.order.pushCom = null;
        this.orderData.order.pushComCode = null;
        this.orderData.order.pushPerson = null;
        this.orderData.order.pushDateTime = null;
        this.orderData.order.receiverCom = null;
        this.orderData.order.receiverComCode = null;
        this.orderData.order.receivePersonId = null;
        this.orderData.order.receiveStatus = null;
        this.orderData.order.receivePerson = null;
        this.orderData.order.receiveDateTime = null;
        this.orderData.order.cancelTime = null;
        this.orderData.order.cancelPerson = null;
        this.orderData.order.cancelExp = null;
        this.orderData.order.pushPrintCount = 0;
        this.orderData.order.deliveryDate = null;
      }
    },
    writeLaterMoney() {
      if (this.orderData.order.paymentMethod == "现金") {
        this.orderData.order.prepay = this.orderData.order.totalMoney;
      } else if (this.orderData.order.paymentMethod == "月结") {
        this.orderData.order.monthBond = this.orderData.order.totalMoney;
      }
    },
    async getInventoryInfo(inventoryId) {
      const { data } = await this.$http.get(
        "/api/inventory-order/getById/" + inventoryId
      );
      if (data.code == 1) {
        this.inventoryOrder = data.data;
        this.orderData.fileInfoList = data.data.fileInfoList;
        this.orderData.order.productName = data.data.order.productName;
        this.orderData.order.colour = data.data.order.colour;
        this.orderData.order.speModel = data.data.order.speModel;
        this.orderData.order.inventoryNo = data.data.order.orderNo;
        this.orderData.order.shop = data.data.order.shop;
        this.orderData.order.sheetMaterial = data.data.order.sheetMaterial;
        this.orderData.order.orderType = "库存订单";
        this.orderData.order.inventoryType = this.$route.query.inventoryType;
        this.orderData.order.remarks = data.data.order.remarks;

        //alert(this.orderData.order.remarks)

        this.initParams();
      }
    },

    //@yaotutu 增加标准库的查询方法

    async getStandardInventoryInfo(standardInventoryId) {
      const { data } = await this.$http.get(
        "/api/standard-inventory-order/getById/" + standardInventoryId
      );
      if (data.code == 1) {
        this.inventoryOrder = data.data;
        this.orderData.fileInfoList = data.data.fileInfoList;
        this.orderData.order.productName = data.data.order.productName;
        this.orderData.order.colour = data.data.order.colour;
        this.orderData.order.speModel = data.data.order.speModel;
        this.orderData.order.inventoryNo = data.data.order.orderNo;
        this.orderData.order.shop = data.data.order.shop;
        this.orderData.order.sheetMaterial = data.data.order.sheetMaterial;
        // this.orderData.order.orderType = "库存订单";
        this.orderData.order.inventoryType = this.$route.query.inventoryType;
        this.orderData.order.remarks = data.data.order.remarks;

        this.initParams();
      }
    },
  },
  created() {
    //解除其他页面的按键监听
    document.onkeydown = null;

    if (this.$route.query.orderId != undefined) {
      //新增售后
      this.getOrderInfo(this.$route.query.orderId);
    } else if (this.$route.query.inventoryId != undefined) {
      //从库存新增
      // this.getInventoryInfo(this.$route.query.inventoryId);
      //@yaotutu 新增了标准页面,这里在增加一个判断,用于区分标准库与之前的库的区别
      if (this.$route.query.pageUpName == "库存列表") {
        console.log("我是从之前的库存列表跳转过来的");
        this.getInventoryInfo(this.$route.query.inventoryId);
      } else if (this.$route.query.pageUpName == "标准库存列表") {
        console.log("我是从标准库存列表跳转过来的");
        this.getStandardInventoryInfo(this.$route.query.inventoryId);
        // console.log(this.$route.query.inventoryId);
      }
    } else {
      //普通新增
      this.initParams();
    }

    this.loadShopInfo();
    this.loadCustomerInfo();
    this.loadPickUpGoodsPhoneList();
  },
};
</script>

<style>
.text_l {
  font-size: 15px;
  margin-top: 0px;
  margin-bottom: 7px;
  font-weight: bold;
}
.text {
  font-size: 13px;
}
.text_del_image {
  font-size: 10px;
}
</style>
